import type { FC } from 'react';
import TopBar from '../components/common/TopBar';
import { useSetTitle } from '../components/hooks/useSetTitle';
import MATHeader from '../components/mat/MATHeader';
import useSetOrg from '../components/hooks/useSetOrg';
import { useParams } from 'react-router';
import MATDiscoveryTable from '../components/mat/MATDiscoveryTable';

const MATDiscoveryPage: FC = () => {
  useSetTitle('MAT Discovery');
  const { dpid } = useParams<'dpid'>();
  useSetOrg(dpid);

  return (
    <div>
      <TopBar />
      <MATHeader />
      <div style={{ padding: '12px 40px 20px' }}>
        <MATDiscoveryTable />
      </div>
    </div>
  );
};

export default MATDiscoveryPage;
